import { render, staticRenderFns } from "./xiaoxi.vue?vue&type=template&id=0b5bcfd6"
import script from "./xiaoxi.vue?vue&type=script&lang=js"
export * from "./xiaoxi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports